export const en = {
    'key-words-limit': 'Limit of {count} keywords exceeded',
    maxLibraryLists: 'No more than 30 negative keywords sets may be added',
    minusPhraseBrackets: 'Square brackets "[" "]" cannot be empty or nested in negative keywords: {subset}',
    minusPhraseBracketsOperator: 'Invalid use of symbols into brackets in keyword: {subset}',
    minusPhraseCharts:
        'You are only allowed to use letters of the Latin, Turkish, Kazakh, Russian, Ukrainian or Belarusian alphabets, quotation marks, square brackets, the symbols "-", "+", "!" and spaces in negative keywords. Errors in keywords: {subset}',
    minusPhraseDots: 'Negative keywords may not contain separate full stops: {subset}',
    minusPhraseEmpty: 'Please complete the negative keywords',
    minusPhraseExclamation: 'Invalid use of "!" in negative keywords: {subset}',
    minusPhraseFirstChar: 'Error in first symbol in keyword: {subset}',
    minusPhraseInvalidDot:
        'Negative keywords can contain no more than two digits after a period. Keywords containing errors: {subset}',
    minusPhraseMax: 'Maximum character length — {count}',
    minusPhraseMaxLengthWordsInMinusPhrase:
        'The maximum length of a word in a negative keyword is {count} characters. Errors in keywords: {subset}',
    minusPhraseMaxWordsInMinusPhrase: 'A negative keyword cannot contain more than {count} words: {subset}',
    minusPhraseMinus: 'Invalid use of "-" in keyword: {subset}',
    minusPhrasePlus: 'Invalid use of "+" in keyword: {subset}',
    minusPhraseQuotes: 'Invalid use of quotation marks in keyword: {subset}',
    minusPhraseSpecialSymbols: 'Invalid combination of special characters in keywords: {subset}',
    'phrase-cannot-be-empty': ' A keyword cannot be empty',
    'phrase-illegal-characters':
        'Only English, Turkish, Kazakh, Russian, Ukrainian, or Belarusian letters, inverted commas, the characters "-", "+", "!", and spaces are allowed in the keyword text. Error in keyword: {phrase}',
    'phrase-incorrect-use-of-parenthesis': 'Operator use error: the keyword may contain unpaired brackets',
    'phrase-invalid-apostrophe': 'Invalid "\'" in the keyword.',
    'phrase-invalid-brackets': 'Invalid square brackets [] in the keyword.',
    'phrase-invalid-exclamation-mark': 'Invalid "!" in the keyword.',
    'phrase-invalid-minus-mark': 'Invalid "-" in the keyword.',
    'phrase-invalid-plus-mark': 'Invalid "+" in the keyword.',
    'phrase-invalid-point': 'Invalid combination of special characters in the keyword',
    'phrase-invalid-quotes': 'Invalid inverted commas in the keyword.',
    'phrase-minus-keywords-max-length':
        'The negative keyword "{minusWord}" is too long (more than {maxLength} characters).',
    'phrase-minus-word-delete-plus-word':
        'You cannot use the word "{word}" from the original keyword as a negative keyword',
    'phrase-minus-word-inside-brackets-or-quotes':
        'You cannot put your negative keywords in inverted commas or square brackets',
    'phrase-no-plus-words': 'A keyword cannot contain negative keywords only',
    'phrase-not-single-minus-word': 'You can only make individual words (but not keywords)  negative within a keyword',
    'phrase-only-stop-words': 'A keyword must consist of more than "stop words" (conjunctions, prepositions, etc.).',
    'phrase-plus-mark-in-brackets': 'The "+" character cannot be used in square brackets',
    'phrase-too-long-keyword': 'The maximum row length in a negative keyword {maxLength} has been exceeded.',
    'phrase-too-long-word':
        'The maximum length for a single keyword of {maxLength} characters has been exceeded. Errors in words: {word}',
    'phrase-too-many-words': 'A keyword cannot contain more than {maxWords} words.',
    'phrases-cannot-be-empty': 'Keywords must be set',
    textError: 'An error occurred ',
    titleEmpty: 'Name cannot be empty',
    titleMax: 'The name of the set must not exceed {count} characters',
    titleSymbols: 'The set name contains invalid characters'
};
